import React, { Fragment } from 'react';
import { Tabs, Tab } from "react-bootstrap";
import ScrollAnimation from 'react-animate-on-scroll';
import Monthly from '../components/paymentItem/Monthly';
import Once from '../components/paymentItem/Once';
import useScript from '../hooks/useScript';

const Payment = props => {

    useScript("https://js.stripe.com/v3");
    return (
        <Fragment>
            <section id="payment" className="payment-section ptb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <ScrollAnimation animateIn="fadeInUp">
                                <div className="section-title">
                                    <h2>付款方法</h2>
                                    <span className="section-title-bg">Payment</span>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="tab-slider">
                                <Tabs activeKey={props.tab} onSelect={tab => props.changeTab(tab)} id="uncontrolled-tab">
                                    <Tab eventKey="monthly" title="月費贊助">
                                        <div className="payment-content"><Monthly /></div>
                                    </Tab>
                                    <Tab eventKey="once" title="單次贊助">
                                        <div className="payment-content"><Once /></div>
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    );

}

export default Payment;